export default "__VITE_ASSET__Daino9Qx__"